import { ShippingOption } from '@medusajs/medusa';
import { useQuery } from '@tanstack/react-query';

import { medusaClient } from '@/services/apiClient';

export const useShippingOptionsByIds = (ids: string[] | null) => {
  return useQuery(['shipping-options-by-methods', ids], async () => {
    const response = await medusaClient.get<ShippingOption[]>(
      '/store/get/shipping-options/methods',
      {
        params: {
          methods: ids,
        },
      },
    );

    const notDuplicateMap = new Map();

    response.data.forEach(option => {
      if (!notDuplicateMap.has(option.name)) {
        notDuplicateMap.set(option.name, option);
      }
    });

    return Array.from(notDuplicateMap.values());
  });
};
